import { Container, Stack, Text, Title } from '@mantine/core';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useMutation } from 'urql';
import { getErrorMessage } from '@/lib/error-message';
import { isTemplatesEnabled } from '@/lib/features';
import { CreatePersonaTemplateMutation } from './-components/graphql';
import { PersonaTemplateEditor, emptyPersonaTemplateValues } from './-components/persona-template-editor';

export const Route = createFileRoute('/_authed/system/persona-templates/new')({
  beforeLoad: () => {
    if (!isTemplatesEnabled()) throw redirect({ to: '/' });
  },
  component: SystemNewPersonaTemplatePage,
});

function SystemNewPersonaTemplatePage() {
  const [, runCreateTemplate] = useMutation(CreatePersonaTemplateMutation);

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <div>
          <Title order={1}>New Persona Template</Title>
          <Text c="dimmed" mt="xs">
            Create a reusable persona template with configurable variables
          </Text>
        </div>
        <PersonaTemplateEditor
          initialValues={emptyPersonaTemplateValues}
          submitLabel="Create"
          onSubmit={async (values) => {
            const result = await runCreateTemplate({
              object: { ...values, category: values.category || null },
            });

            return result.error || !result.data?.insertPersonaTemplatesOne
              ? getErrorMessage(result.error, 'Failed to create template')
              : null;
          }}
        />
      </Stack>
    </Container>
  );
}
